import React, { useState, useEffect, useRef } from "react";
import { socket } from "../../utils/socket";
import axios from "axios";
import { Send, Image as ImageIcon } from "lucide-react";
import { MdOutlineCancel } from "react-icons/md";

const Chat = ({ booking }) => {
  // console.log("booking : " , booking)
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");
  const [image, setImage] = useState(null);
  const chatEndRef = useRef(null);

  useEffect(() => {
    socket.emit("receive message", { data: { bookingId: booking._id } });
    socket.on("receive message", (data) => {
      if (data.bookingId === booking._id) {
        setMessages(data.messages);
      }
    });
    return () => socket.off("receive message");
  }, [booking._id]);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const sendMessage = async () => {
    if (!message.trim() && !image) return;

    if (image) {
      // console.log("image :", image);
      const formData = new FormData();
      formData.append("image", image);
      formData.append("bookingId", booking._id);
      formData.append("senderId", booking.user._id);
  
        try{

          const response = axios.post("https://wavetechservices.in/upload-image", 
            formData, 
            {
            headers: { "Content-Type": "multipart/form-data" },
            })
  
            if (response.data.error) {
              console.error("Image upload error:", response.data.error);
            } 
        } catch(error){
          console.error("Image upload request failed:", error);
        }

      setImage(null);
    } else {
      const msgData = {
        event: "chat message",
        data: {
          bookingId: booking._id,
          senderId: booking.user._id,
          receiverId: booking.partner._id,
          message,
          image: null,
          type: "text",
          timestamp: new Date().toISOString(),
        },
      };
      // console.log("msgData : ", msgData);
      socket.emit("chat message", msgData);
      setMessage("");
    }
  };

  function formatTime(isoString) {
    const dateObj = new Date(isoString);
    let hours = dateObj.getHours();
    const minutes = dateObj.getMinutes().toString().padStart(2, "0");
    const amPm = hours >= 12 ? "PM" : "AM";
  
    // Convert hours from 24-hour to 12-hour format
    hours = hours % 12 || 12; 
  
    return `${hours}:${minutes} ${amPm}`;
  }

  console.log("messages :", messages);
  return (
    <div className="flex flex-col w-full max-w-lg mx-auto  ">
      <div className="h-[600px] overflow-y-auto bg-white  rounded">
        {messages.length > 0 ? (
          messages.map((msg, index) => (
            <div
              key={index}
              className={`flex items-center gap-2 ${
                msg.data.senderId === booking.user._id
                  ? "justify-end"
                  : "justify-start"
              }`}
            >
              {msg.data.senderId !== booking.user._id && (
                <img
                  // src={`https://wavetechservices.in/uploads/profiles/${booking.partner.profilePicture}`}
                  src={`${booking.partner.profilePicture}`}
                  alt="Profile"
                  className="size-7 rounded-full"
                />
              )}
              {msg.data.message ? (
                <div
                  className={`p-1 px-3 my-1 mx-3  text-sm rounded-2xl w-fit max-w-xs ${
                    msg.data.receiverId !== booking.user._id
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-black"
                  }`}
                >
                  <div className="flex flex-row gap-2 justify-center ">

                   <p className="">{msg?.data?.message}</p>
                    <p className="text-[9px] flex items-center ">{formatTime(msg?.data?.timestamp)} </p> 
                  </div>
                </div>
              ) : (
                <div className="px-3 rounded-2xl w-fit max-w-xs ">
                  {msg.data.image && (
                    <img
                      src={`${msg.data.image}`}
                      alt="Sent"
                      className="mt-2 w-40 rounded-lg"
                    />
                  )}
                  
                </div>
              )}
            </div>
          ))
        ) : (
          <p className="text-gray-500 text-center">No messages yet.</p>
        )}
        <div className="flex flex-row justify-center">
          {image && (
            <div className="relative mt-2 w-20 h-20">
              <img
                src={URL.createObjectURL(image)}
                alt="Preview"
                className="w-full h-full object-cover rounded-md"
              />
              <button
                onClick={() => setImage(null)}
                className="absolute top-0 right-0 rounded-full  text-red-500 shadow-md"
              >
                <MdOutlineCancel className="w-4 h-4" />
              </button>
            </div>
          )}
        </div>
        <div ref={chatEndRef} />
      </div>

      <div className="flex mt-5">
        <input
          type="text"
          className="flex-1 text-black p-2 border border-r-0 rounded-l-3xl focus:outline-none"
          placeholder="Type a message..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        <label className="flex flex-row items-center cursor-pointer   text-black border-y hover:text-gray-600">
          {/* <label className="cursor-pointer px-3 bg-blue-500 border-t border-b"> */}
          <ImageIcon className="" />
          {/* <ImageIcon className="w-6 h-6 text-white hover:text-gray-600" /> */}
          <input
            type="file"
            accept="image/*"
            className="hidden"
            onChange={(e) => setImage(e.target.files[0])}
          />
        </label>
        <button
          className="px-4  text-black border-r border-y rounded-r-3xl  hover:text-gray-600"
          onClick={sendMessage}
        >
          <Send />
        </button>
      </div>
    </div>
  );
};

export default Chat;
